// removed by extract-text-webpack-plugin
module.exports = {"close":"src-components-Common-Close-index-close-30MaR"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Common/Close/index.css
 ** module id = 258
 ** module chunks = 0
 **/